import $ from 'jquery';
import debounce from 'cmnjs/function/debounce';
import config from './config';

let $dropdown;
let $dropdownTrigger;
let $dropdownArrow;
let dropdownArrowAnimatedClass;
let isIE;
let animateDuration;

function animationToggle(elem) {
  elem.slideToggle({
    duration: animateDuration,
    start: () => {
      $dropdownArrow.toggleClass(dropdownArrowAnimatedClass);
    },
  });
}

function checkIE() {
  const ua = navigator.userAgent;

  if (ua.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > -1) {
    isIE = true;
  }
}

function init() {
  $dropdown = $('.js-languages-dropdown');
  $dropdownTrigger = $('.js-languages-dropdown-trigger');
  $dropdownArrow = $('.js-languages-dropdown-arrow');
  dropdownArrowAnimatedClass = 'menu__languages-element-arrow--animated';
  isIE = false;

  $dropdownTrigger.on('click', e => {
    e.preventDefault();

    animationToggle($dropdown);
  });

  config.$el.window.on('scroll touchmove', debounce(() => {
    if ($dropdown.is(':not(:hidden)')) {
      animationToggle($dropdown);
    }
  }, 200));

  checkIE();

  animateDuration = isIE ? 0 : 400;
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/languageSwitcher.js